module.exports = "<svg viewBox=\"0 0 24 16\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill=\"none\" stroke=\"#fff\" stroke-width=\"3\" stroke-miter-limit=\"10\" d=\"M0,1h24 M0,8h24 M0,15h24\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/hamburger.svg
// module id = 797
// module chunks = 1